import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { ApolloLink } from '@apollo/client';
import { getUserDistinctId } from '@crehana/utils';
var distinctIdLink = /*#__PURE__*/new ApolloLink(function (operation, forward) {
  var distinctId = '';
  if (typeof window !== 'undefined') {
    distinctId = getUserDistinctId().distinctId;
  }
  operation.setContext(function (_ref) {
    var _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers;
    return {
      headers: _objectSpread(_objectSpread({}, headers), {}, {
        'session-distinct-id': distinctId
      })
    };
  });
  return forward(operation);
});
export default distinctIdLink;